// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-3vrDo";
var _4 = "link-3-Otr";
var _5 = "title-3qqYx";
var _6 = "icon-1q914";
var _7 = "multiCity-1j0Qy";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "link", _5 as "title", _6 as "icon", _7 as "multiCity" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "link": _4, "title": _5, "icon": _6, "multiCity": _7 }
